import React from 'react';

// Why Did You Render
// https://github.com/welldone-software/why-did-you-render

if (process.env.DEBUG) {
	const whyDidYouRender = require('@welldone-software/why-did-you-render');

	whyDidYouRender(React, {
		trackAllPureComponents: true,
	});

	// Uncomment to track all components
	//React.Component.whyDidYouRender = true;
}
